import {creditSvg as Icon__small__creditSvg} from '../Icon__small/Icon__small--credit.js';

export var credit = {
  name: 'credit',
  category: 'icon',
  colorable: true,
  svg: Icon__small__creditSvg,
};
